export class OrderOverviewModel {
  from: string;
  to: string;
  totalItems: number;
  filterType: string;
  orderNumbers: string[];
}
